/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface OKSpinConfig extends SDKConfig {
  trackingId: string; // GTM-XXXXXXX
}

declare global {
  interface Window {
    _okTag: any;
    OKSpinPixel: any;
  }
}

export class OKSpinSDK extends BaseSDK {
  constructor(config: OKSpinConfig) {
    super(SDKName.OKSpinSDK, config);
  }

  async initialize(): Promise<void> {
    const config = this.config as OKSpinConfig;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://s.oksp.in/js/tag.js?aa=${config.trackingId}`;
    document.head.appendChild(script);
    window.OKSpinPixel = config.trackingId;
  }

  getOKSpinEventName(event: string) {
    let okspinEvent = "";
    switch (event) {
      case "register":
        okspinEvent = "EVENT_COMPLETE_REGISTRATION";
        break;
      case "purchase":
        okspinEvent = "EVENT_PURCHASE";
        break;
      case "first_purchase":
        okspinEvent = "EVENT_FIRST_DEPOSIT";
        break;
      case "contentview":
        okspinEvent = "EVENT_CONTENT_VIEW";
        break;
      case "browseropen":
        okspinEvent = "EVENT_PWA_OPEN";
        break;
    }
    return okspinEvent;
  }

  reportEvent(event: string, data: Record<string, unknown>): boolean {
    try {
      if (window.OKSpinPixel) {
        const eventName = this.getOKSpinEventName(event);
        if (eventName) {
          window._okTag = window._okTag || [];
          window._okTag.push({
            eid: eventName,
            data,
          });
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
}
